import { render } from "./Index.vue?vue&type=template&id=1082d8bb"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Pages/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1082d8bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1082d8bb', __exports__)) {
    api.reload('1082d8bb', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=1082d8bb", () => {
    api.rerender('1082d8bb', render)
  })

}


export default __exports__